import React, { useState, useEffect } from "react";
import { doc, setDoc, getFirestore } from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  listAll,
  getMetadata,
} from "firebase/storage";
import { useStorageContext } from "./../../Context/StorageContext";

import { mirage } from 'ldrs'








export default function UploadHandler({ images, handleSelectShopImage }) {
  const storage = getStorage();
  mirage.register()
  const { rerenderImages } = useStorageContext();
  const [alreadyExists, setAlreadyExists] = useState(false);
  const [metadatasShop, setMetadatasShop] = useState({});
  const [metadatas, setMetadatas] = useState({});
  const [url, setUrl] = useState(null);

  const [image, setImage] = useState(null);
  const [uploadingShop, setUploadingShop] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [bigImg, setBigImg] = useState(false);

  const [counter, setCounter] = useState(0);
  const [dragenter, setDragenter] = useState(false);

  const drag = () => {
    setDragenter(true);
  };

  const dragleave = () => {
    setDragenter(false);
  };

  const handleUploadShopImage = () => {
    const storageRef = ref(storage, `images/${image.name}`);
    getMetadata(storageRef)
      .then(
        (metadata) =>
          // El archivo ya existe, hacer algo aquí
          setAlreadyExists(true),
        setTimeout(() => {
          setAlreadyExists(false);
        }, 4000)
      )
      .catch((error) => {
        if (error.code == "storage/object-not-found") {
          // El archivo no existe, cargarlo aquí
          setUploadingShop(true);
          uploadBytes(storageRef, image)
            .then((metadata) => {
              setMetadatasShop(metadata);
            })
            .then(() => {
              if (metadatas !== {}) {
                getDownloadURL(storageRef)
                  .then((url) => setUrl(`${url}`))
                  .then(() => setUploaded(true), setUploadingShop(false))
                  .then(() => rerenderImages())
                  .catch((error) => console.log(error));
              } else {
              }
            });
        } else {
          // Manejar otros errores aquí
          console.log(error);
        }
      });
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].size < 5000000) {
      setImage(e.target.files[0]);
    } else {
      setBigImg(true);

      setTimeout(() => {
        setBigImg(false);
      }, 4000);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setImage(e.dataTransfer.files[0]);
  };


  const handleSelectShopImageF = () => {
    handleSelectShopImage(url);
  };

  const addMore = () => {
    setUploaded(false)
    setImage(false)
    setMetadatas({})
  }



  return (
  
<div> 
<div className={uploadingShop === true ? 'dropArea uploading' : dragenter === true ? "dropArea dragEnter" : 'dropArea'}
            onDrop={handleDrop}
            onDragEnter={drag}
            onDragLeave={dragleave}
            onDragOver={(e) => e.preventDefault()}>

            <p className='dragText'> {image ? <></> : "Arrastrá una foto"} </p>

             

            {uploaded === true ?
              <img className="uploadImg" src="https://img.icons8.com/external-kiranshastry-solid-kiranshastry/64/FFFFFF/external-check-multimedia-kiranshastry-solid-kiranshastry.png" /> :

              <img className={image ? "uploadImg" : "uploadImgF"} src="https://img.icons8.com/ios-filled/100/FFFFFF/send-letter--v1.png" />
            }


            {image && (
              <div className='dragCont'>
                <p className='dragText'>{image.name} </p>

                {uploaded === true ?

                  <></>

                  :
                  <button className='buttonbyn' onClick={handleUploadShopImage}>
                    {uploadingShop === true ?

                
                        
           
                        <l-mirage
  size="30"
  speed="2.5" 
  color="black" 
></l-mirage>

              
                  
                      

                      : "Subir archivo"}

                  </button>

                }

              
                 {  uploaded === true
                    ?
                    <button className='buttonbyn ' type='submit' onClick={addMore
                    }> ¡Listo! Agregar otra</button>: <></> 

                    }

      

              </div>
            )}


                 {/* <div className="inputCont">
        <label className="inputLabel" htmlFor="name">
          {" "}
          Foto (hasta 200kb)
        </label>
        {uploaded === true ? (
          <button
            className="uploadButtonItems bgreen"
            onClick={handleSelectShopImageF}
          >
            ¡Listo! <br /> Publicar
          </button>
        ) : (
          <>
            {" "}
            <input
              className="marginauto"
              type="file"
              onChange={handleChange}
              size="2242880"
            />
            <button
              className="uploadButtonItems"
              onClick={handleUploadShopImage}
            ></button>{" "}
          </>
        )}

        {bigImg === true ? (
          <p className="bigImgCont">
            El archivo supera los 500kb. Probá con uno de menor tamaño.
          </p>
        ) : (
          <></>
        )}

        {alreadyExists === true ? (
          <p className="alreadyExists">
            {" "}
            Ya existe un archivo con ese nombre. Pruebe modificándolo y vuelva a
            intentar.
          </p>
        ) : (
          <></>
        )}
      </div> */}
          </div>

 {!image ? 
 <div className="column">
    O seleccionala acá
 <input className='input' type="file" onChange=
                            {handleChange} accept="image/*,.jpg,.png,.jpeg" />
 </div>
 : ""}
</div>


  );
}
